import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/universal/header";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { InventoryLotsTable } from "./-inventory-batches-table";

export const Route = createFileRoute(
  "/_private/_inventory-360/inventory-lot/lookup/",
)({
  component: InventoryBatchLookup,
});

function InventoryBatchLookup() {
  return (
    <div>
      <title>Lots - Legrande Health Portal</title>
      <Header
        crumbs={[{ name: "Lots", link: { to: "/inventory-lot/lookup" } }]}
      />
      <Card>
        <CardHeader>
          <CardTitle>Lots</CardTitle>
          <CardDescription>View all lots across products.</CardDescription>
        </CardHeader>
        <CardContent>
          <InventoryLotsTable />
        </CardContent>
      </Card>
    </div>
  );
}
